import { motion } from "framer-motion";
import { scrollToId } from "@/lib/lenis";

const EASE = [0.16, 1, 0.3, 1];

export default function FinalCta() {
  return (
    <section className="relative bg-ink py-28 sm:py-36 lg:py-44 overflow-hidden" data-testid="final-cta-section">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.06),transparent_60%)]" />
      <div className="relative max-w-4xl mx-auto px-5 sm:px-8 text-center">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-[11px] uppercase tracking-[0.35em] text-copper-hover mb-7"
          data-testid="final-cta-eyebrow"
        >
          The Only Question That Remains
        </motion.p>
        <div className="overflow-hidden">
          <motion.h2
            initial={{ y: "105%" }}
            whileInView={{ y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1, ease: EASE }}
            className="font-serif text-4xl sm:text-6xl lg:text-7xl text-gold font-medium tracking-tight leading-[1.1]"
            data-testid="final-cta-heading"
          >
            How Long Will You Operate
          </motion.h2>
        </div>
        <div className="overflow-hidden mt-1">
          <motion.h2
            initial={{ y: "105%" }}
            whileInView={{ y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1, delay: 0.12, ease: EASE }}
            className="font-serif italic text-4xl sm:text-6xl lg:text-7xl text-gold-soft font-medium tracking-tight leading-[1.1]"
          >
            on Borrowed Voltage?
          </motion.h2>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.35, ease: EASE }}
          className="mt-12"
        >
          <button
            data-testid="final-cta-button"
            onClick={() => scrollToId("#intake-application")}
            className="bg-copper hover:bg-copper-hover text-white font-semibold uppercase tracking-[0.22em] text-xs sm:text-sm px-10 sm:px-14 py-4 sm:py-5 transition-colors duration-300 shadow-[0_0_34px_rgba(184,115,51,0.35)] hover:shadow-[0_0_48px_rgba(184,115,51,0.55)] active:scale-[0.98]"
          >
            Begin Executive Intake
          </button>
        </motion.div>
      </div>
    </section>
  );
}
